import {environment} from '../../../environments/environment';

export enum AppPlatform {
	Facebook = 'facebook',
	Google = 'google',
	TikTok = 'tiktok',
	Pinterest = 'pinterest',
	LinkedIn = 'linkedin',
	Express = 'express',
	Taboola = 'taboola'
}

export const AppPlatformLabels = {
	[AppPlatform.Facebook]: 'Facebook',
	[AppPlatform.Google]: 'Google',
	[AppPlatform.TikTok]: 'TikTok',
	[AppPlatform.Pinterest]: 'Pinterest',
	[AppPlatform.LinkedIn]: 'LinkedIn',
	[AppPlatform.Express]: 'Digitaleo Ads',
	[AppPlatform.Taboola]: 'Taboola',
};

const ASSETS_SOURCE_PATH = `${environment.aws.cloudfrontHost}${environment.aws.bucketDirectory}`;

export const AppPlatformIcons = {
	[AppPlatform.Facebook]: `${ASSETS_SOURCE_PATH}/facebook_ads-logo.svg`,
	[AppPlatform.Google]: `${ASSETS_SOURCE_PATH}/google_ads-logo.svg`,
	[AppPlatform.TikTok]: `${ASSETS_SOURCE_PATH}/tiktok-logo.svg`,
	[AppPlatform.Pinterest]: `${ASSETS_SOURCE_PATH}/pinterest-logo.svg`,
	[AppPlatform.LinkedIn]: `${ASSETS_SOURCE_PATH}/linkedin-logo.svg`,
	[AppPlatform.Express]: `${ASSETS_SOURCE_PATH}/express-logo.svg`,
	[AppPlatform.Taboola]: `${ASSETS_SOURCE_PATH}/taboola-logo.svg`,
};

export const AppPlatformList = (Object.keys(AppPlatformLabels) as AppPlatform[])
	.map((key: AppPlatform) => ({
		value: key,
		label: AppPlatformLabels[key],
	}));

export const ALL_OPTION_COMPATIBLE_PLATFORMS: AppPlatform[] = [
	AppPlatform.Express
];
